import { ReactElement } from 'react';

import { IconFillColor, IconSize, IconWrapper, ShieldProtectedIcon } from '@dreryk/react-components';

import { isConfidentialHiddenEntry } from './confidentialResourceAccess.utils';

type ConfidentialMaskProps = {
   readonly entry: {
      readonly confidential: boolean;
      readonly hasAccess: boolean;
   };
   readonly children: () => ReactElement | null;
};

export const ConfidentialMask = (props: ConfidentialMaskProps): ReactElement | null => {
   if (isConfidentialHiddenEntry(props.entry)) {
      return (
         <IconWrapper size={IconSize.SMALL} testId={'confidentialShield'} fillColor={IconFillColor.BACKGROUND}>
            <ShieldProtectedIcon />
         </IconWrapper>
      );
   }

   return props.children();
};
